module.exports = __webpack_public_path__ + "assets/img/releasefile.9a65fac5.svg";